import mixpanel from "mixpanel-browser";
mixpanel.init('38282722ef8d1cda1aa712f104497184');

let env_check = process.env.NODE_ENV === "production";

let actions = {
  identify: (id) => {
    if (env_check) mixpanel.identify(id);
    else console.log("id", id);
  },
  track: (name, props) => {
    if (env_check) mixpanel.track(name, props);
    else console.log("track", name, props);
  },
  people: {
    set: (props) => {
      if (env_check) mixpanel.people.set(props);
      else console.log("set", props);
    },
  },
  reset: () => {
    if (env_check) mixpanel.reset();
    else console.log("reset");
  },
};

 

export const Mixpanel = actions;
